import React from "react"
import styled, { keyframes } from "styled-components"
import PropTypes from "prop-types"

const rootAnimation = keyframes`
 from {
    transform: scale3d(1, 1, 1);
  }

  50% {
    transform: scale3d(1
    .25, 1.25, 1.25);
  }

  to {
    transform: scale3d(1, 1, 1);
  }
`
const tickAnimation = keyframes`

  
  from{
      stroke-dasharray: 24;
      stroke-dashoffset: 24;
  }
  to{
    stroke-dashoffset: 0;
  }
`

export const AnimatedTick = styled(props => (
  <svg
    className={props.className}
    viewBox="0 0 18 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g transform="matrix(1,0,0,1,0,0.262563)">
      <path id="tick" d="M3.075,8.025L7.025,12.00L15.5,2.5" />
    </g>
  </svg>
))`
  stroke-linecap: round;
  stroke-linejoin: miter;
  fill-rule: evenodd;
  clip-rule: evenodd;
  animation: ${rootAnimation} 0.4s ease-in-out 0.2s forwards;
  width: ${props => (props.width ? props.width + `px` : `100%`)};

  #tick {
    stroke: ${props => props.theme.colors.coral};
    stroke-dasharray: 24;
    stroke-dashoffset: 24;
    animation: ${tickAnimation} 0.2s ease-in-out 0.2s forwards;
    fill: none;
    stroke-width: 4px;
  }
`
AnimatedTick.propTypes = {
  width: PropTypes.number,
}
